export default __webpack_public_path__ + "static/CuervoVP-conEscenarioVirtual2jc-a24c662deeeaceed24979f95818db229.jpg";